import { SingleInfoItem } from "./components/TitleInfo/types";

export const renderAvailableData = (list: SingleInfoItem[]) =>
    list.filter(item => item.isAvailable);
